import api from '@services/api';

/**
 * Загружает данные документа по REFDOCISN (POST /quotation/docs).
 * В currentDocInfo попадают DocSpecs, Docs, DocRow, ecpRedirect, ecpRedirectUrl.
 * Если бэкенд возвращает обёртку { data: { ... } }, разворачиваем один уровень.
 */
export const getDocData = async (refDocIsn: string) => {
  const { data } = await api.doc.getDocInfoByAgrIsn(refDocIsn);
  return data?.data ?? data;
};
